import React, { useEffect, useState } from "react";

function AnimatedDigit({ value }) {
  const [prev, setPrev] = useState(value);

  useEffect(() => {
    if (value !== prev) {
      setPrev(value);
    }
  }, [value, prev]);

  return (
    <div className="digit-wrapper">
      <div className="digit-scroll" style={{ transform: `translateY(-${value * 10}%)` }}>
        {Array.from({ length: 10 }, (_, i) => (
          <div className="digit" key={i}>{i}</div>
        ))}
      </div>
    </div>
  );
}

export default AnimatedDigit;
